import {LitElement, html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import * as Toastify from 'toastify-js';
//import { __ } from '@wordpress/i18n';

@customElement( 'im-user-menu' )
export class UserMenu extends LitElement {

  @property( { attribute: 'dropdown-id' } )
  dropdownId: string = 'user-dropdown';

  @property( { reflect: true } )
  initials: string;

  @property( { type: Array } )
  categories: Array<any> = [];

  @state()
  private _signOutButtonDisabled = false;

  constructor() {
    super();

    this.categories = [
      {
        slug: 'a',
        name: 'Qatar 2022',
      },
      {
        slug: 'b',
        name: 'Fútbol internacional',
      },
      {
        slug: 'c',
        name: 'Fútbol peruano',
      },
    ];
  }

  createRenderRoot() {
    return this;
  }

  private async _logOut() {
    try {
      const url = new URL( window.infonews.rest_base_url + 'infonews/v1/logout' );
      
      const promise = await fetch( url, {
        method: 'post',
      } );
      
      const response = await promise.json();

      if ( response.loggedOut ) {
        const toast = Toastify( {
          text: "Has cerrado tu sesión.",
          duration: 3000,
          gravity: "bottom", // `top` or `bottom`
          position: "center", // `left`, `center` or `right`
          onClick: function() {
              if (toast) {
                  toast.hideToast();
              }
          }
        } ) as any;
        
        toast.showToast();

        return true;
      }
    }
    catch ( error ) {
      //localStorage.removeItem( 'infonews_subscriber' );
      return false;
    }

    return false;
  } 

  private _handleLogOut() {
    this._signOutButtonDisabled = true;

    this._logOut().then( () => {
      this._signOutButtonDisabled = false;


      
      window.location.reload();
    } );
  }

  private _renderToggleButton() {
    return html`
      <im-user-avatar class="cursor-pointer current-user" data-dropdown-toggle="${ this.dropdownId }" initials="${ this.initials }"></im-user-avatar>
    `;
  }

  private _renderDropdown() {
    return html`
      <div id="${ this.dropdownId }" class="hidden rounded p-4 shadow bg-light-card-background dark:bg-dark-card-background absolute w-80 overflow-hidden">
        <div class="flex justify-center items-center h-6 relative">
          <img class="w-24 block dark:hidden" src="${ window.infonews.logo.grayscale_light }">
          <img class="w-24 hidden dark:block" src="${ window.infonews.logo.grayscale_dark }">

          <!--<button
            class="w-6 flex items-center justify-center text-light-meta dark:text-dark-meta absolute right-0"
            data-dropdown-toggle="${ this.dropdownId }"
          >
            <i class="fa-regular fa-xmark"></i>
          </button>-->
        </div>

        <div class="my-6 flex">
          <im-user-avatar class="current-user" initials="${ this.initials }"></im-user-avatar>

          <div class="ml-4">
            <div class="text-sm text-light-body dark:text-dark-body">Javier Távara</div>
            <div class="text-xs text-light-meta dark:text-dark-meta">javier@tavara.pe</div>
          </div>
        </div>

        <!--<div class="my-6">
          <div class="mb-4">
            <div class="text-sm font-medium text-light-body dark:text-dark-body">Notificaciones</div>
            <p class="text-xs text-light-meta dark:text-dark-meta">Recibirás notificaciones de estas secciones.</p>
          </div>

          <div>
            ${this.categories.map( (category) =>
              html`
                <custom-toggle class="block mb-2" ids-value="${ category.slug }" ids-label="${ category.name }"></custom-toggle>
              `
            ) }
          </div>
        </div>-->

        <hr class="my-6">

        <div class="text-center">
          <button class="btn btn_secondary" ?disabled=${ this._signOutButtonDisabled } @click="${this._handleLogOut}">
            <i class="fa-regular fa-right-from-bracket mr-2"></i> Cerrar sesión
          </button>
        </div>
      </div>
    `;
  }

  // Render the UI as a function of component state
  render() {
    return html`
      <div class="relative">
        ${ this._renderToggleButton() }
        ${ this._renderDropdown() }
      </div>
    `;
  }
}
